import { Component, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'c-cookies',
    templateUrl: './cookies.component.html',
    styleUrl: './cookies.component.css',
    standalone: false
})
export class CookiesComponent {
  private readonly cookieService = inject(CookieService);

  accepted = false;

  ngOnInit() {
    const accepted = this.cookieService.get('policies');
    if (accepted) this.accepted = true;
  }

  acceptCookies() {
    this.cookieService.set('policies', 'accepted');
    this.accepted = true;
  }
}
